(function() {
  service.$inject = ["$timeout"];
  app.service('panelScrollService', service);

  function service($timeout) {
    var _this = this;

    this.position = {
      x: 0,
      y: 0
    };

    this.scrollToSaved = function () {
      $timeout(function () {
        window.scrollTo(_this.position.x, _this.position.y);
      }, 100);
    };

    this.saveAndUp = function () {
      var doc = document.documentElement;
      _this.position.x = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
      _this.position.y = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
      window.scrollTo(0, 0);
    };
  }
}());



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/panelScroll/service.js